import * as $ajax from './_ajax'
import * as $msg from './_msg'
import * as $notifications from './_notifications'
import * as $types from './_types'

export function toggleCompleted(id: string, callback: any = null): void {
    $ajax.post({
        loadingText: 'Sparar...',
        url: '/Owner/ToggleNoteComplete',
        data: {
            id: id,
        },
        success: function (res: $types.object.IJsonResult) {
            if (res.Ok) {
                $notifications.load()
                if (callback) callback()
            } else {
                $msg.showError(res.Message)
            }
        },
    })
}

export function createNote(
    agareId: string,
    text: string,
    aterkomst: string,
    visibility: string,
    callback: any = null
): void {
    $ajax.post({
        loadingText: 'Sparar...',
        url: '/Owner/CreateNote',
        data: {
            agareId: agareId,
            text: text,
            aterkomst: aterkomst,
            visibility: visibility,
        },
        success: function (res: $types.object.IJsonResult) {
            if (res.Ok) {
                $notifications.load()
                if (callback) callback()
            } else {
                $msg.showError(res.Message)
            }
        },
    })
}

export function deleteNote(id: string, callback: any = null): void {
    if (confirm('Är du säker på att du vill radera denna notering?')) {
        $ajax.post({
            loadingText: 'Raderar...',
            url: '/Owner/DeleteNote',
            data: {
                id: id,
            },
            success: function (res: $types.object.IJsonResult) {
                if (res.Ok) {
                    $notifications.load()
                    if (callback) callback()
                } else {
                    $msg.showError(res.Message)
                }
            },
        })
    }
}
